import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenuButton,
  IonModal,
  IonNote,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSkeletonText,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import API from "../lib/API";

import StringUtils from "../lib/StringUtils";

import chicken from "../assets/img/icons/protein_chicken_white.svg";
import beef from "../assets/img/icons/protein_beef_white.svg";
import pork from "../assets/img/icons/protein_pork_white.svg";
import turkey from "../assets/img/icons/protein_turkey_white.svg";
import plant from "../assets/img/icons/protein_plant_white.svg";
import egg from "../assets/img/icons/protein_egg_white.svg";
import other from "../assets/img/icons/protein_other_white.svg";
import fish from "../assets/img/icons/protein_fish_white.svg";
import glutenFree from "../assets/img/icons/gluten_free.svg";
import _ from "underscore";

import myfitnesspal from "../assets/img/icons/myfitnesspal.svg";
import LinkUtils from "../lib/LinkUtils";
import {
  checkmarkCircle,
  chevronForward,
  star,
  starOutline,
} from "ionicons/icons";
import StorageUtils from "../lib/StorageUtils";
import WindowUtils from "../lib/WindowUtils";
import { Capacitor } from "@capacitor/core";
import MealOptionCardNoSelection from "./MealOptionCardNoSelection";
import MealOptionCard from "./MealOptionCard";
import MealDetailModal from "./MealDetailModal";
import Constants from "../lib/Constants";

const MealDetailContentV2: React.FC<{
  meal: any;
  showReview?: boolean;
  showQuantity?: boolean;
  presentingElement?: any;
  skeleton?: boolean;
  showReturnToApp?: boolean;
  nativeMode?: boolean;
  allowFavorite?: boolean;
  favorites?: any;
  onFavoriteChange?: any;
  modalID?: string;
}> = ({
  meal = null,
  showReview = false,
  showQuantity = false,
  presentingElement = null,
  skeleton = false,
  showReturnToApp = false,
  nativeMode = false,
  allowFavorite = false,
  favorites = [],
  onFavoriteChange = () => {},
  modalID = "",
}) => {
  const w: any = window;
  const settingsDesktopRef: any = useRef();
  const settingsRef: any = useRef();
  const [rating, setRating] = useState<any>(null);
  const [comments, setComments] = useState<any>("");
  const [heatingMicrowave, setHeatingMicrowave] = useState<any>(false);
  const [heatingOther, setHeatingOther] = useState<any>(false);
  const [heatingAirFryer, setHeatingAirFryer] = useState<any>(false);
  const [heatingOven, setHeatingOven] = useState<any>(false);
  const [heatingStove, setHeatingStove] = useState<any>(false);
  const [submitting, setSubmitting] = useState<any>(false);
  const [confirm, setConfirm] = useState<any>(false);
  const history = useHistory();
  const [segment, setSegment] = useState<any>("about");

  useEffect(() => {
    setSegment("about");
  }, [meal?._id]);

  /**
   * Clears the data state
   */
  const clearDataState = () => {
    setHeatingAirFryer(false);
    setHeatingMicrowave(false);
    setHeatingOven(false);
    setHeatingStove(false);
    setHeatingOther(false);
    setComments("");
    setRating(null);
  };

  /**
   * Callback to handle feedback
   *
   * @param data
   */
  const onFeedbackSuccess = (data: any) => {
    clearDataState();

    setConfirm(true);

    setTimeout(() => {
      setConfirm(false);
    }, 5000);
  };

  /**
   * Handles submitting feedback
   *
   * @returns
   */
  const submitFeedback = async () => {
    if (!rating) {
      return;
    }

    let heating: any = [];

    if (heatingMicrowave) {
      heating.push("Microwave");
    }

    if (heatingOther) {
      heating.push("Other");
    }

    if (heatingAirFryer) {
      heating.push("Air Fryer");
    }

    if (heatingOven) {
      heating.push("Oven");
    }

    if (heatingStove) {
      heating.push("Stove");
    }

    setSubmitting(true);

    const user = await StorageUtils.get("user_customer");

    API.submitMealFeedback(
      meal?._id,
      rating,
      heating,
      comments ? comments : "",
      user?.storeID ? user?.storeID : "",
    )
      .then(
        (res: any) => {
          settingsDesktopRef?.current?.dismiss();
          settingsRef?.current?.dismiss();

          onFeedbackSuccess(res?.data?.data);
        },
        (e: any) => {
          console.error(e);
        },
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  /**
   * Handles submitting feedback
   */
  const handleFeedback = (rating: number, openModal: boolean = false) => {
    setRating(rating);

    if (openModal) {
      const { width }: any = WindowUtils.getDimensions();

      if (width >= 768) {
        settingsDesktopRef?.current?.present();
      } else {
        settingsRef.current?.present();
      }
    }
  };

  const categories = (meal: any) => {
    if (!meal?.categories?.length) {
      return [];
    }

    return _.sortBy(meal?.categories, "name");
  };

  const getProteinIcon = (meal: any) => {
    if (!meal?.primaryProteinCategory) {
      return "";
    }

    const cat = meal?.primaryProteinCategory?.toLowerCase();

    if (cat == "chicken") {
      return chicken;
    }

    if (cat == "beef") {
      return beef;
    }

    if (cat == "pork") {
      return pork;
    }

    if (cat == "turkey") {
      return turkey;
    }

    if (cat == "fish") {
      return fish;
    }

    if (cat == "plant based") {
      return plant;
    }

    if (cat == "lean cheat") {
      return other;
    }

    if (cat == "egg") {
      return egg;
    }
  };

  const feedbackForm = useCallback(
    (desktopMode = false) => {
      return (
        <>
          <IonRow className="ion-justify-content-center pb-2">
            <IonCol sizeXs="auto" className="pr-2 pl-0 pb-0">
              <div
                className="text-left cursor-pointer"
                style={{ color: "var(--yellow)", fontSize: 40, lineHeight: 1 }}
                onClick={() => {
                  handleFeedback(1);
                }}
              >
                <IonIcon icon={rating >= 1 ? star : starOutline}></IonIcon>
              </div>
            </IonCol>
            <IonCol sizeXs="auto" className="px-2 pb-0">
              <div
                className="text-left cursor-pointer"
                style={{ color: "var(--yellow)", fontSize: 40, lineHeight: 1 }}
                onClick={() => {
                  handleFeedback(2);
                }}
              >
                <IonIcon icon={rating >= 2 ? star : starOutline}></IonIcon>
              </div>
            </IonCol>
            <IonCol sizeXs="auto" className="px-2 pb-0">
              <div
                className="text-left cursor-pointer"
                style={{ color: "var(--yellow)", fontSize: 40, lineHeight: 1 }}
                onClick={() => {
                  handleFeedback(3);
                }}
              >
                <IonIcon icon={rating >= 3 ? star : starOutline}></IonIcon>
              </div>
            </IonCol>
            <IonCol sizeXs="auto" className="px-2 pb-0">
              <div
                className="text-left cursor-pointer"
                style={{ color: "var(--yellow)", fontSize: 40, lineHeight: 1 }}
                onClick={() => {
                  handleFeedback(4);
                }}
              >
                <IonIcon icon={rating >= 4 ? star : starOutline}></IonIcon>
              </div>
            </IonCol>
            <IonCol sizeXs="auto" className="pl-2 pr-0 pb-0">
              <div
                className="text-left cursor-pointer"
                style={{ color: "var(--yellow)", fontSize: 40, lineHeight: 1 }}
                onClick={() => {
                  handleFeedback(5);
                }}
              >
                <IonIcon icon={rating >= 5 ? star : starOutline}></IonIcon>
              </div>
            </IonCol>
          </IonRow>
          <h4 className="font-weight-bold mt-4 text-dark mb-4 text-center">
            How Did You Heat It?
          </h4>
          <div className="mb-4 text-center">
            <IonGrid className="p-0">
              <IonRow className="ion-justify-content-center">
                <IonCol sizeXs="auto" className="px-0">
                  <IonChip
                    mode="ios"
                    color={heatingMicrowave ? "primary" : "dark"}
                    outline={heatingMicrowave ? false : true}
                    onClick={() => {
                      setHeatingMicrowave(!heatingMicrowave);
                    }}
                  >
                    Microwave
                  </IonChip>
                </IonCol>
                <IonCol sizeXs="auto" className="px-0">
                  <IonChip
                    mode="ios"
                    color={heatingAirFryer ? "primary" : "dark"}
                    outline={heatingAirFryer ? false : true}
                    onClick={() => {
                      setHeatingAirFryer(!heatingAirFryer);
                    }}
                  >
                    Air Fryer
                  </IonChip>
                </IonCol>
                <IonCol sizeXs="auto" className="px-0">
                  <IonChip
                    mode="ios"
                    color={heatingOven ? "primary" : "dark"}
                    outline={heatingOven ? false : true}
                    onClick={() => {
                      setHeatingOven(!heatingOven);
                    }}
                  >
                    Oven
                  </IonChip>
                </IonCol>
                <IonCol sizeXs="auto" className="px-0">
                  <IonChip
                    mode="ios"
                    color={heatingStove ? "primary" : "dark"}
                    outline={heatingStove ? false : true}
                    onClick={() => {
                      setHeatingStove(!heatingStove);
                    }}
                  >
                    Stove
                  </IonChip>
                </IonCol>
                <IonCol sizeXs="auto" className="px-0">
                  <IonChip
                    mode="ios"
                    color={heatingOther ? "primary" : "dark"}
                    outline={heatingOther ? false : true}
                    onClick={() => {
                      setHeatingOther(!heatingOther);
                    }}
                  >
                    Other
                  </IonChip>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
          <h4 className="font-weight-bold mt-4 text-dark mb-4 text-center">
            Additional Feedback
          </h4>
          <textarea
            placeholder="Comments"
            style={{
              width: "calc(100% - 1px)",
              height: 100,
              borderRadius: 6,
              border: "1px solid var(--light)",
              padding: 10,
              fontSize: 18,
              resize: "none",
              color: "var(--dark)",
              background: "white",
            }}
            value={comments}
            onChange={(e: any) => {
              setComments(e?.target?.value);
            }}
          ></textarea>
          {!desktopMode && (
            <IonButton
              className={`pln-button-web mt-4`}
              expand="block"
              color={"primary"}
              disabled={!rating || submitting}
              onClick={() => {
                submitFeedback();
              }}
            >
              {submitting ? <IonSpinner name="dots"></IonSpinner> : "Submit"}
            </IonButton>
          )}
        </>
      );
    },
    [
      rating,
      heatingOther,
      heatingAirFryer,
      heatingMicrowave,
      heatingOven,
      heatingStove,
      comments,
      submitting,
    ],
  );

  const getCategory = (meal: any) => {
    return _.findWhere(meal?.categories, { name: "Lean Cheats" })
      ? "Lean Cheats"
      : meal?.planType?.name;
  };

  return (
    <>
      <div className="d-block d-md-none">
        {skeleton ? (
          <>
            <div
              style={{
                height: 240,
                width: "100%",
                position: "relative",
                background: "var(--midlighter)",
                overflow: "hidden",
                borderBottom: "1px solid var(--midlighter)",
              }}
              className=""
            ></div>
          </>
        ) : (
          <>
            <div
              className={`${
                !Capacitor.isNativePlatform() ||
                Capacitor.getPlatform() == "ios"
                  ? "ion-padding"
                  : "ion-padding py-0"
              } border-b-[1px] border-gray-100`}
              style={{
                position: "sticky",
                top: 0,
                width: "100%",
                zIndex: 999,
                background: "#FFF",
              }}
            >
              <IonSegment
                value={segment}
                onIonChange={(e: any) => {
                  console.log(e.detail.value);

                  setSegment(e.detail.value);
                }}
              >
                <IonSegmentButton value="about" className="text-sm">
                  About
                </IonSegmentButton>
                <IonSegmentButton value="nutrition">Nutrition</IonSegmentButton>
                <IonSegmentButton value="heating">Heating</IonSegmentButton>
              </IonSegment>
            </div>

            {segment == "about" ? (
              <>
                <div
                  className={`pb-4 bg-white ${
                    getCategory(meal) == "Lean Cheats" ? "-mt-4" : "pt-4"
                  }`}
                >
                  <div className="relative min-h-[337px] mb-4">
                    <div
                      style={{
                        transform: "translateX(-50%)",
                        left: "50%",
                        boxShadow: `10px 10px 4px 0px rgba(0,0,0,0.5)`,
                      }}
                      className={`absolute  aspect-square  ${
                        getCategory(meal) == "Lean Cheats"
                          ? "rounded-[2.5rem] w-[71%] top-[12%] max-w-[390px]"
                          : "rounded-[100%] w-[85%] top-[7px] max-w-[475px]"
                      }`}
                    ></div>
                    <img
                      src={
                        meal?.platedImageURL
                          ? meal?.platedImageURL
                          : meal?.imageURL
                      }
                      alt={meal?.name}
                      style={{
                        width: "90%",
                        maxWidth: 500,
                        position: "relative",
                        left: "50%",
                        transform: "translateX(-50%)",
                      }}
                    ></img>
                    <div
                      style={{
                        position: "absolute",
                        left: "1rem",
                        bottom: "0.5rem",
                        background: "#111411",
                        borderRadius: "100%",
                        width: 35,
                        height: 35,
                      }}
                      className="text-right "
                    >
                      <img
                        src={getProteinIcon(meal)}
                        style={{ width: "35px" }}
                      ></img>
                    </div>
                    <div
                      style={{
                        position: "absolute",
                        right: "1rem",
                        bottom: "0.5rem",
                        background: "#111411",
                        borderRadius: "100%",
                        width: 35,
                        height: 35,
                      }}
                      className="text-right "
                    >
                      <img src={glutenFree} style={{ width: "35px" }}></img>
                    </div>
                  </div>

                  <h1 className="px-[1rem] leading-8 font-[700] text-2xl font-[SourceSerif] font-medium text-gray-900 ">
                    {meal?.name}
                  </h1>
                  <p className="text-lg text-gray-900 mt-0 mb-0 px-[1rem] pb-[0.75rem] pt-[0.25rem] leading-6">
                    {StringUtils.htmlToText(meal?.description)}
                  </p>
                  <div className="flex px-[1rem] mb-2 max-w-[100%] flex-wrap">
                    {meal?.spicy ? (
                      <div
                        style={{ lineHeight: 1 }}
                        className="flex gap-x-[0.4rem] items-center text-lg relative mr-[0.75rem] mb-2 text-gray-900 bg-white"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="140px"
                          height="185px"
                          viewBox="0 0 140 185"
                          version="1.1"
                          style={{
                            height: 14,
                            width: "auto",
                            position: "relative",
                            top: -1,
                          }}
                        >
                          <title>Meal Heat Flame</title>
                          <g
                            id="Meal-Heat-Flame"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path
                              d="M107.681558,0.0427138334 C107.659186,0.0643153614 107.637728,0.0869484654 107.617246,0.110547115 C90.7193105,5.68520951 77.1764537,22.2532462 69.8716471,40.7059469 C62.8424875,58.4622994 61.7742218,77.9317946 69.2919377,91.4332384 C58.843956,92.1203807 50.0433588,89.4909601 45.1373211,81.8453565 C39.9927803,73.8280793 38.8693021,60.0655214 45.0084773,38.4619868 C45.11997,38.0538801 44.9963276,37.6145904 44.6918305,37.3369706 C44.3873335,37.0593508 43.9576496,36.994155 43.5914148,37.170005 C9.18969463,55.8789305 -4.47664656,92.8150112 1.27256306,125.092861 C7.02172892,157.370712 32.2868081,185 74.9602098,185 C94.77662,185 111.592939,177.831255 123.140599,164.532188 C134.688259,151.233341 140.928016,131.844035 139.887794,107.685035 C138.843459,80.1224131 125.131181,67.2739748 114.895824,54.5777429 C109.778168,48.2296489 105.567777,41.903777 103.945745,33.770038 C102.323714,25.636321 103.289933,15.5507234 108.905486,1.53852578 C109.072021,1.15188858 109.010228,0.698295065 108.747234,0.376870473 C108.48424,0.0554458807 108.068124,-0.0750500267 107.681558,0.0426697859 L107.681558,0.0427138334 Z"
                              id="Path"
                              fill="#F5365C"
                            />
                          </g>
                        </svg>
                        <div
                          style={{
                            lineHeight: 1,
                            position: "relative",
                          }}
                          className="text-lg text-base"
                        >
                          Spice
                        </div>
                      </div>
                    ) : null}
                    {categories(meal)?.map((cat: any) => (
                      <div
                        key={cat?._id}
                        className="text-lg text-gray-900 bg-white d-inline-block mr-[0.75rem] mb-2"
                        style={{}}
                      >
                        {cat?.name}
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-x-5 px-[1rem] items-end flex-wrap">
                    <div>
                      <p className="text-2xl font-[700] m-0 text-gray-900">
                        {meal?.nutrition?.calories}
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Calories
                      </p>
                    </div>
                    <div>
                      <p className="text-xl font-[700] m-0 text-gray-900">
                        {meal?.nutrition?.protein}g
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Protein
                      </p>
                    </div>
                    <div>
                      <p className="text-xl font-[700] m-0 text-gray-900">
                        {meal?.nutrition?.carbs}g
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Carbs
                      </p>
                    </div>
                    <div>
                      <p className="text-xl font-[700] m-0 text-gray-900">
                        {meal?.nutrition?.fat}g
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Fats
                      </p>
                    </div>
                    <div>
                      <p className="text-lg font-[700] m-0 text-gray-900">
                        {meal?.nutrition?.sodium}mg
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Sodium
                      </p>
                    </div>
                    <div>
                      <p className="text-lg font-[700] m-0 text-gray-900">
                        {meal?.cholesterol}mg
                      </p>
                      <p className="text-gray-900 font-medium m-0 text-base">
                        Cholesterol
                      </p>
                    </div>
                  </div>

                  {meal?.limitedAvailability && !meal?.outOfStock ? (
                    <div className="my-4 mx-[1rem] bg-yellow-50 border-[1px] border-yellow-500 rounded-lg p-2">
                      <p className="m-0">
                        {skeleton ? (
                          <IonSkeletonText
                            className="mt-3"
                            animated={true}
                            style={{ width: "100%", height: 30 }}
                          ></IonSkeletonText>
                        ) : (
                          <>
                            <span className="font-weight-bold">
                              Limited Stock:
                            </span>{" "}
                            This item currently has a limited supply
                            available.&nbsp;
                            {meal?.swapForMeal ? (
                              <>
                                If {meal?.name} is unavailable, you'll receive{" "}
                                {meal?.swapForMeal?.name} instead.
                              </>
                            ) : (
                              <>
                                If {meal?.name} is unavailable when your order
                                is prepared, you'll receive a replacement from
                                the other items you selected.
                              </>
                            )}
                          </>
                        )}
                      </p>
                      {meal?.swapForMeal ? (
                        <>
                          <div className="rounded-lg border-[1px] border-yellow-500 overflow-hidden bg-white mt-2">
                            <MealOptionCard
                              meal={meal?.swapForMeal}
                              mobile={true}
                              compact={true}
                              modalID={"swapfor-modal"}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  ) : null}
                  {meal?.outOfStock ? (
                    <div className="my-4 mx-[1rem] bg-yellow-50 border-[1px] border-yellow-500 rounded-lg p-2">
                      <p className="m-0">
                        {skeleton ? (
                          <IonSkeletonText
                            className="mt-3"
                            animated={true}
                            style={{ width: "100%", height: 30 }}
                          ></IonSkeletonText>
                        ) : (
                          <>
                            <span className="font-weight-bold">
                              Out Of Stock:
                            </span>{" "}
                            This item is currently unavailable.&nbsp;
                            {meal?.quantity > 0 ? (
                              <>
                                {meal?.swapForMeal ? (
                                  <>
                                    If {meal?.name} is still unavailable when
                                    your order is prepared, you'll receive{" "}
                                    {meal?.swapForMeal?.name} instead.
                                  </>
                                ) : (
                                  <>
                                    If {meal?.name} is still unavailable when
                                    your order is prepared, you'll receive a
                                    replacement from the other items you
                                    selected.
                                  </>
                                )}
                              </>
                            ) : (
                              <>
                                We hope you'll enjoy one of our other delicious
                                options!
                              </>
                            )}
                          </>
                        )}
                      </p>
                      {meal?.swapForMeal ? (
                        <>
                          <div className="rounded-lg border-[1px] border-yellow-500 overflow-hidden bg-white mt-2">
                            <MealOptionCard
                              meal={meal?.swapForMeal}
                              mobile={true}
                              compact={true}
                              modalID={"swapfor-modal"}
                            />
                          </div>
                        </>
                      ) : null}
                    </div>
                  ) : null}
                  {showReview && !skeleton ? (
                    <>
                      <div className="mt-4 mb-2 px-3">
                        <IonCard
                          onClick={() => {
                            handleFeedback(0, true);
                          }}
                          button={true}
                          mode="ios"
                          className="border m-0 shadow-sm"
                        >
                          <IonCardContent className="p-3">
                            <IonGrid className="p-0">
                              <IonRow className="ion-align-items-center">
                                <IonCol sizeXs="" className="pl-0">
                                  <h1
                                    style={{ fontSize: 18 }}
                                    className="text-gray-900 font-weight-bold my-0"
                                  >
                                    Rate {meal?.name}
                                  </h1>
                                  <p
                                    style={{ fontSize: 15 }}
                                    className="mb-0 mt-1 text-gray-900"
                                  >
                                    {confirm
                                      ? "Thanks for your feedback!"
                                      : "Let us know what you think!"}
                                  </p>
                                  <div
                                    className="mt-1"
                                    style={{
                                      fontSize: 20,
                                      lineHeight: 1,
                                      color: "var(--yellow)",
                                    }}
                                  >
                                    {confirm ? (
                                      <IonIcon
                                        color="success"
                                        icon={checkmarkCircle}
                                      />
                                    ) : (
                                      <>
                                        <IonIcon
                                          icon={star}
                                          className="p-0 my-0 mr-2"
                                        />
                                        <IonIcon
                                          icon={star}
                                          className="p-0 my-0 mr-2"
                                        />
                                        <IonIcon
                                          icon={star}
                                          className="p-0 my-0 mr-2"
                                        />
                                        <IonIcon
                                          icon={star}
                                          className="p-0 my-0 mr-2"
                                        />
                                        <IonIcon
                                          icon={star}
                                          className="p-0 my-0 mr-2"
                                        />
                                      </>
                                    )}
                                  </div>
                                </IonCol>
                                <IonCol sizeXs="auto" className="pr-0">
                                  <div style={{ fontSize: 26, lineHeight: 1 }}>
                                    <IonIcon
                                      color="dark"
                                      icon={chevronForward}
                                    />
                                  </div>
                                </IonCol>
                              </IonRow>
                            </IonGrid>
                          </IonCardContent>
                        </IonCard>
                      </div>
                    </>
                  ) : null}

                  <h2 className="px-[1rem] mt-3 leading-10 font-medium text-xl font-[SourceSerif] text-gray-900">
                    Protein Source{meal?.secondaryProteinCategory ? "s" : ""}
                  </h2>
                  <p className="text-lg text-gray-900 mt-0 mb-0 px-[1rem] pb-[0.75rem] pt-[0.25rem] leading-6">
                    {meal?.primaryProteinCategory == "Lean Cheat"
                      ? meal?.primaryProtein?.includes("Plant Based")
                        ? "Plant Based Protein"
                        : "Whey Protein"
                      : meal?.primaryProteinCategory}
                    {meal?.secondaryProteinCategory
                      ? `, ${meal?.secondaryProteinCategory}`
                      : ""}
                  </p>

                  <h2 className="px-[1rem] mt-0 leading-10 font-medium text-xl font-[SourceSerif] text-gray-900">
                    Allergens
                  </h2>
                  
                  <p className="text-lg text-gray-900 mt-0 mb-0 px-[1rem] pb-[0.75rem] pt-[0.25rem] leading-6">
                    {meal?.allergens?.length
                      ? meal?.allergens
                          ?.map((allergen: any) => {
                            return allergen?.name;
                          })
                          ?.join(", ")
                      : "No Allergens Specified"}
                  </p>
                  <div className="text-left px-[1rem]"> 
                  <p className="text-sm text-gray-500">Please notify our team if you have a food allergy, intolerance, or dietary restriction so we can best assist you.</p>
              </div>
                </div>
              </>
            ) : null}
            {segment == "nutrition" ? (
              <>
                <div>
                  <div className={`${skeleton && "d-none"} pr-3 -mt-2`}>
                    <h2
                      style={{ fontSize: 22 }}
                      className="text-dark px-[1rem] mb-1 font-medium font-[SourceSerif] pt-4 mb-0"
                    >
                      Nutrition Facts
                    </h2>
                    <IonList mode="ios" color="white" className="bg-white">
                      <IonItem color="transparent">
                        <IonLabel>Serving Size</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {_.findWhere(meal?.categories, {
                            name: "Lean Cheats",
                          })
                            ? "3 Protein Balls"
                            : "1 Meal"}
                          &nbsp;(~{meal?.foodWeight} oz)
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Calories</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.calories} CAL
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Protein</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.protein}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Carbohydrates</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.carbs}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Sugar</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.sugar}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Added Sugar</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.addedSugar}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Dietary Fiber</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.fiber}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Fat</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.fat}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Saturated Fat</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.saturatedFat}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Trans Fat</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.transFat}g
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Sodium</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.nutrition?.sodium}mg
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Cholesterol</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.cholesterol}mg
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Vitamin D</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.vitaminD} IU
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Potassium</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.potassium}mg
                        </IonLabel>
                      </IonItem>
                      <IonItem color="transparent">
                        <IonLabel>Calcium</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.calcium}mg
                        </IonLabel>
                      </IonItem>
                      <IonItem lines="none" color="transparent">
                        <IonLabel>Iron</IonLabel>
                        <IonLabel slot="end" className="mr-0">
                          {meal?.iron}mg
                        </IonLabel>
                      </IonItem>
                    </IonList>
                  </div>
                  <div className={`px-[1rem] bg-white ${skeleton && "d-none"}`}>
                    <h2
                      style={{ fontSize: 22 }}
                      className="text-dark font-[SourceSerif] font-medium pt-4 mb-0"
                    >
                      Ingredients
                    </h2>
                    <div
                      className="mt-3 mb-4 text-capitalize ingredient-list"
                      style={{ lineHeight: 1.4, fontSize: 17 }}
                    >
                      {meal?.ingredients}
                    </div>
                  </div>
                  <div
                    className={`pb-4 mt-[2rem] px-[1rem] bg-white ${
                      skeleton && "d-none"
                    }`}
                  >
                    <h2
                      style={{ fontSize: 22 }}
                      className="text-dark leading-7 font-[SourceSerif] font-medium mb-0"
                    >
                      Committed To High Quality, Healthy Ingredients
                    </h2>
                    <div
                      className="mt-3 mb-5 ingredient-list"
                      style={{ lineHeight: 1.4, fontSize: 17 }}
                    >
                      <p className="mb-3">
                        We believe that great health starts with great
                        ingredients. That's why we carefully select quality,
                        nutritious, and minimally processed ingredients for
                        every meal. From vegetables harvested at their peak
                        freshness to thoughtfully prepared whole proteins, we
                        prioritize the best so you can feel your best.
                      </p>
                      <p>
                        We partner with trusted suppliers who share our
                        commitment to quality and sustainability. This means you
                        can count on every dish to be packed with the nutrients
                        you need, without compromising on taste or health. Enjoy
                        peace of mind knowing each meal is crafted to support
                        your wellness journey.
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            {segment == "heating" ? (
              <>
                <div className={`${skeleton && "d-none"} pb-5 bg-white`}>
                  {StringUtils.htmlToText(
                    meal?.microwaveInstructions,
                  )?.trim() ==
                  Constants.HEATING_INSTRUCTIONS_NOT_HEATED?.trim() ? (
                    <>
                      <h2
                        style={{ fontSize: 22 }}
                        className="text-dark px-[1rem] mb-1 mt-3 font-weight-bold mb-0"
                      >
                        No Heating Required
                      </h2>
                      <div className="text-base text-gray-900 px-[1rem] pt-2">
                        This item does not need to be heated to enjoy!
                      </div>
                    </>
                  ) : (
                    <>
                      {meal?.microwaveInstructions ? (
                        <>
                          <h2 className="text-dark text-[22px] px-[1rem] mb-1 mt-3 font-[SourceSerif] font-medium mb-0">
                            Microwave Instructions
                          </h2>
                          <div
                            className="text-base text-gray-900 px-[1rem]"
                            style={{ fontSize: 14 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.microwaveInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium text-lg">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium text-lg">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </>
                      ) : null}
                      {meal?.airFryInstructions ? (
                        <>
                          {meal?.microwaveInstructions ? (
                            <hr className="my-4 mx-0 w-full"></hr>
                          ) : null}
                          <h2 className="text-dark text-[22px] px-[1rem] mb-1 mt-2 font-[SourceSerif] font-medium mb-0">
                            Air Fryer Instructions
                          </h2>
                          <div
                            className="text-base text-gray-900 px-[1rem]"
                            style={{ fontSize: 14 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.airFryInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium text-lg">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium text-lg">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </>
                      ) : null}
                      {meal?.ovenInstructions ? (
                        <>
                          {meal?.microwaveInstructions ||
                          meal?.airFryInstructions ? (
                            <hr className="my-4 mx-0 w-full"></hr>
                          ) : null}
                          <h2 className="text-dark text-[22px] px-[1rem] mb-1 mt-2 font-[SourceSerif] font-medium mb-0">
                            Oven Instructions
                          </h2>
                          <div
                            className="text-base text-gray-900 px-[1rem]"
                            style={{ fontSize: 14 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.ovenInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium text-lg">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium text-lg">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </>
                      ) : null}
                    </>
                  )}
                  <div
                    className={`pb-4 mt-[3rem] px-[1rem] bg-white ${
                      skeleton && "d-none"
                    }`}
                  >
                    <h2
                      style={{ fontSize: 22 }}
                      className="text-dark leading-7 font-[SourceSerif] font-medium mb-0"
                    >
                      Meal Storage
                    </h2>
                    <div
                      className="mt-3 mb-0 ingredient-list"
                      style={{ lineHeight: 1.4, fontSize: 17 }}
                    >
                      <p className="">
                        All of our meals are flash frozen at peak freshness to
                        lock in flavor and nutrition. For best results, store
                        meals in the freezer and transfer them to your
                        refrigerator the evening before you plan to enjoy them.
                        Meals stay fresh for up to 6 months in the freezer and
                        up to 5 days in the fridge. Once thawed, we do not
                        recommend refreezing.
                      </p>
                    </div>
                  </div>
                  <div
                    className={`pb-4 mt-[2rem] px-[1rem] bg-white ${
                      skeleton && "d-none"
                    }`}
                  >
                    <h2
                      style={{ fontSize: 22 }}
                      className="text-dark leading-7 font-[SourceSerif] font-medium mb-0"
                    >
                      About Our Packaging
                    </h2>
                    <div
                      className="mt-3 mb-5 ingredient-list"
                      style={{ lineHeight: 1.4, fontSize: 17 }}
                    >
                      <p className="mb-3">
                        We use Vacuum Skin Packaging (VSP) to keep your meals
                        fresh, safe, and delicious. This advanced technology
                        locks out oxygen, preserving the natural flavors and
                        nutrients of our food. Our meals are thoughtfully
                        packaged so you can enjoy high-quality, nutritious food
                        whenever you're ready to eat!
                      </p>
                      <p>
                        We're also committed to sustainability. Our packaging is
                        designed to reduce waste & environmental impact while
                        keeping your meals protected. With Project LeanNation,
                        you can feel good knowing your meals are packaged with
                        care for both you and the environment.
                      </p>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </>
        )}
        {showQuantity && meal?.quantity > 0 && (
          <>
            <div
              className="px-1 py-1 text-white font-weight-bold text-uppercase"
              style={{
                fontSize: 14,
                lineHeight: 1,
                borderRadius: 3,
                position: "absolute",
                right: "0.5rem",
                top: "0.5rem",
                background: "var(--primary-darker)",
              }}
            >
              {meal?.quantity} In Box
            </div>
          </>
        )}
      </div>

      <div className="mx-3 mt-3 d-none d-md-block">
        {skeleton ? (
          <div
            style={{
              height: 280,
              width: "100%",
              borderRadius: 6,
              position: "relative",
              background: "var(--midlighter)",
              overflow: "hidden",

              border: "1px solid var(--midlighter)",
            }}
            className=""
          ></div>
        ) : (
          <>
            <div
              style={{
                height: 320,
                width: "100%",
                borderRadius: 6,
                position: "relative",
                background: "var(--white)",
                overflow: "hidden",
                border: "1px solid var(--lighter)",
              }}
              className=""
            >
              <img
                src={
                  meal?.platedImageURL ? meal?.platedImageURL : meal?.imageURL
                }
                alt={meal?.name}
                style={{
                  width: "100%",
                  maxWidth: 500,
                  position: "absolute",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  top: "50%",
                }}
              ></img>
              <div
                style={{
                  position: "absolute",
                  left: "0.5rem",
                  bottom: "0.5rem",
                  background: "#111411",
                  borderRadius: "100%",
                  width: 40,
                  height: 40,
                }}
                className="text-right "
              >
                <img src={getProteinIcon(meal)} style={{ width: "40px" }}></img>
              </div>
              <div
                style={{
                  position: "absolute",
                  right: "0.5rem",
                  bottom: "0.5rem",
                  background: "#111411",
                  borderRadius: "100%",
                  width: 40,
                  height: 40,
                }}
                className="text-right "
              >
                <img src={glutenFree} style={{ width: "40px" }}></img>
              </div>
              {showQuantity && meal?.quantity > 0 && (
                <>
                  <div
                    className="px-1 py-1 text-white font-weight-bold text-uppercase"
                    style={{
                      fontSize: 14,
                      lineHeight: 1,
                      borderRadius: 3,
                      position: "absolute",
                      right: "0.5rem",
                      top: "0.5rem",
                      background: "var(--primary-darker)",
                    }}
                  >
                    {meal?.quantity} In Box
                  </div>
                </>
              )}
            </div>

            <h1 className="leading-10 font-[700] mt-3 text-2xl text-gray-900">
              {meal?.name}
            </h1>
            <p className="text-lg font-medium text-gray-900 mt-0 mb-0 pb-[0.75rem] pt-[0.5rem] leading-6">
              {StringUtils.htmlToText(meal?.description)}
            </p>
            <div className="flex max-w-[100%] mb-[0.5rem] gap-y-3 flex-wrap">
              {meal?.spicy ? (
                <div
                  style={{ lineHeight: 1 }}
                  className="flex gap-x-[0.4rem]  py-[0.1rem] items-center text-lg relative mr-3 mb-2 rounded-lg text-gray-900 bg-white"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="140px"
                    height="185px"
                    viewBox="0 0 140 185"
                    version="1.1"
                    style={{
                      height: 14,
                      width: "auto",
                      position: "relative",
                      top: -1,
                    }}
                  >
                    <title>Meal Heat Flame</title>
                    <g
                      id="Meal-Heat-Flame"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <path
                        d="M107.681558,0.0427138334 C107.659186,0.0643153614 107.637728,0.0869484654 107.617246,0.110547115 C90.7193105,5.68520951 77.1764537,22.2532462 69.8716471,40.7059469 C62.8424875,58.4622994 61.7742218,77.9317946 69.2919377,91.4332384 C58.843956,92.1203807 50.0433588,89.4909601 45.1373211,81.8453565 C39.9927803,73.8280793 38.8693021,60.0655214 45.0084773,38.4619868 C45.11997,38.0538801 44.9963276,37.6145904 44.6918305,37.3369706 C44.3873335,37.0593508 43.9576496,36.994155 43.5914148,37.170005 C9.18969463,55.8789305 -4.47664656,92.8150112 1.27256306,125.092861 C7.02172892,157.370712 32.2868081,185 74.9602098,185 C94.77662,185 111.592939,177.831255 123.140599,164.532188 C134.688259,151.233341 140.928016,131.844035 139.887794,107.685035 C138.843459,80.1224131 125.131181,67.2739748 114.895824,54.5777429 C109.778168,48.2296489 105.567777,41.903777 103.945745,33.770038 C102.323714,25.636321 103.289933,15.5507234 108.905486,1.53852578 C109.072021,1.15188858 109.010228,0.698295065 108.747234,0.376870473 C108.48424,0.0554458807 108.068124,-0.0750500267 107.681558,0.0426697859 L107.681558,0.0427138334 Z"
                        id="Path"
                        fill="#F5365C"
                      />
                    </g>
                  </svg>
                  <div
                    style={{
                      lineHeight: 1,
                      position: "relative",
                    }}
                    className="font-[500] text-lg text-base"
                  >
                    Spice
                  </div>
                </div>
              ) : null}
              {categories(meal)?.map((cat: any) => (
                <div
                  key={cat?._id}
                  className="font-[500] text-lg text-gray-900 mb-2 d-inline-block mr-3"
                  style={{}}
                >
                  {cat?.name}
                </div>
              ))}
            </div>
            <div className="flex gap-x-5 mb-3 items-end">
              <div>
                <p className="text-2xl font-[700] m-0 text-gray-900">
                  {meal?.nutrition?.calories}
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">
                  Calories
                </p>
              </div>
              <div>
                <p className="text-xl font-[700] m-0 text-gray-900">
                  {meal?.nutrition?.protein}g
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">
                  Protein
                </p>
              </div>
              <div>
                <p className="text-xl font-[700] m-0 text-gray-900">
                  {meal?.nutrition?.carbs}g
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">Carbs</p>
              </div>
              <div>
                <p className="text-xl font-[700] m-0 text-gray-900">
                  {meal?.nutrition?.fat}g
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">Fats</p>
              </div>
              <div>
                <p className="text-lg font-[700] m-0 text-gray-900">
                  {meal?.nutrition?.sodium}mg
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">
                  Sodium
                </p>
              </div>
              <div>
                <p className="text-lg font-[700] m-0 text-gray-900">
                  {meal?.cholesterol}mg
                </p>
                <p className="text-gray-900 font-medium m-0 text-base">
                  Cholesterol
                </p>
              </div>
            </div>
            {meal?.limitedAvailability && !meal?.outOfStock ? (
              <div className="mt-4 bg-yellow-50 border-[1px] border-yellow-500 rounded-lg p-2">
                <p className="m-0">
                  {skeleton ? (
                    <IonSkeletonText
                      className="mt-3"
                      animated={true}
                      style={{ width: "100%", height: 30 }}
                    ></IonSkeletonText>
                  ) : (
                    <>
                      <span className="font-weight-bold">Limited Stock:</span>{" "}
                      This item currently has a limited supply available.&nbsp;
                      {meal?.swapForMeal ? (
                        <>
                          If {meal?.name} is unavailable, you'll receive{" "}
                          {meal?.swapForMeal?.name} instead.
                        </>
                      ) : (
                        <>
                          If {meal?.name} is unavailable when your order is
                          prepared, you'll receive a replacement from the other
                          items you selected.
                        </>
                      )}
                    </>
                  )}
                </p>
                {meal?.swapForMeal ? (
                  <>
                    <div className="rounded-lg border-[1px] border-yellow-500 overflow-hidden bg-white mt-2">
                      <MealOptionCard
                        meal={meal?.swapForMeal}
                        mobile={true}
                        compact={true}
                        modalID={"swapfor-modal"}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
            {meal?.outOfStock ? (
              <div className="mt-4 bg-yellow-50 border-[1px] border-yellow-500 rounded-lg p-2">
                <p className="m-0">
                  {skeleton ? (
                    <IonSkeletonText
                      className="mt-3"
                      animated={true}
                      style={{ width: "100%", height: 30 }}
                    ></IonSkeletonText>
                  ) : (
                    <>
                      <span className="font-weight-bold">Out of Stock:</span>{" "}
                      This item is currently unavailable.&nbsp;
                      {meal?.quantity > 0 ? (
                        <>
                          {meal?.swapForMeal ? (
                            <>
                              If {meal?.name} is still unavailable when your
                              order is prepared, you'll receive{" "}
                              {meal?.swapForMeal?.name} instead.
                            </>
                          ) : (
                            <>
                              If {meal?.name} is still unavailable when your
                              order is prepared, you'll receive a replacement
                              from the other items you selected.
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          We hope you'll enjoy one of our other delicious
                          options!
                        </>
                      )}
                    </>
                  )}
                </p>
                {meal?.swapForMeal ? (
                  <>
                    <div className="rounded-lg border-[1px] border-yellow-500 overflow-hidden bg-white mt-2">
                      <MealOptionCard
                        meal={meal?.swapForMeal}
                        mobile={true}
                        compact={true}
                        modalID={"swapfor-modal"}
                      />
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
            <h2 className="mt-3 leading-10 font-bold text-xl text-gray-900">
              Protein Source{meal?.secondaryProteinCategory ? "s" : ""}
            </h2>
            <p className="text-lg font-[500] text-gray-900 mt-0 mb-0 pb-[0.75rem] pt-[0.25rem] leading-6">
              {meal?.primaryProteinCategory == "Lean Cheat"
                ? meal?.primaryProtein?.includes("Plant Based")
                  ? "Plant Based Protein"
                  : "Whey Protein"
                : meal?.primaryProteinCategory}
              {meal?.secondaryProteinCategory
                ? `, ${meal?.secondaryProteinCategory}`
                : ""}
            </p>

            <h2 className="mt-2 leading-10 font-bold text-xl text-gray-900">
              Allergens
            </h2>
            <p className="text-lg font-[500] text-gray-900 mt-0 mb-0 pb-[0.75rem] pt-[0.25rem] leading-6">
              {meal?.allergens?.length
                ? meal?.allergens
                    ?.map((allergen: any) => {
                      return allergen?.name;
                    })
                    ?.join(", ")
                : "No Allergens Specified"}
            </p>
            <div className="text-left"> 
                  <p className="text-sm text-gray-500">Please notify our team if you have a food allergy, intolerance, or dietary restriction so we can best assist you.</p>
              </div>
            <div className={`${skeleton && "d-none"} pr-3 mb-3`}>
              <IonList mode="ios" className="ml--3">
                <IonListHeader>
                  <IonLabel>Nutrition Facts</IonLabel>
                </IonListHeader>
                <IonItem>
                  <IonLabel>Serving Size</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {_.findWhere(meal?.categories, { name: "Lean Cheats" })
                      ? "3 Protein Balls"
                      : "1 Meal"}
                    &nbsp;(~{meal?.foodWeight} oz)
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Calories</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.calories} CAL
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Protein</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.protein}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Carbohydrates</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.carbs}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Sugar</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.sugar}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>AddedSugar</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.addedSugar}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Dietary Fiber</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.fiber}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Fat</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.fat}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Saturated Fat</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.saturatedFat}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Trans Fat</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.transFat}g
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Sodium</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.nutrition?.sodium}mg
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Cholesterol</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.cholesterol}mg
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Vitamin D</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.vitaminD} IU
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Potassium</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.potassium}mg
                  </IonLabel>
                </IonItem>
                <IonItem>
                  <IonLabel>Calcium</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.calcium}mg
                  </IonLabel>
                </IonItem>
                <IonItem lines="none">
                  <IonLabel>Iron</IonLabel>
                  <IonLabel slot="end" className="mr-0">
                    {meal?.iron}mg
                  </IonLabel>
                </IonItem>
              </IonList>
            </div>
            <div className={`mb-1 pt-[1.5rem] ${skeleton && "d-none"}`}>
              <h2
                style={{ fontSize: 22 }}
                className="text-dark font-[SourceSerif] font-medium mb-0"
              >
                Ingredients
              </h2>
              <div
                className="mt-3 mb-5 text-capitalize ingredient-list"
                style={{ lineHeight: 1.4, fontSize: 17 }}
                dangerouslySetInnerHTML={{
                  __html: StringUtils.ingredientsToHTML(meal?.ingredients),
                }}
              ></div>
            </div>
            <div className={`${skeleton && "d-none"} pr-3`}>
              <IonList mode="ios" className="ml--3">
                <IonListHeader>
                  <IonLabel>Heating Instructions</IonLabel>
                </IonListHeader>
                {StringUtils.htmlToText(meal?.microwaveInstructions)?.trim() ==
                Constants.HEATING_INSTRUCTIONS_NOT_HEATED?.trim() ? (
                  <IonItem lines="none">
                    <IonLabel class="ion-text-wrap text-base text-gray-900">
                      <div className="text-base text-gray-900">
                        This item does not need to be heated to enjoy!
                      </div>
                    </IonLabel>
                  </IonItem>
                ) : (
                  <>
                    {meal?.microwaveInstructions ? (
                      <IonItem>
                        <IonLabel class="ion-text-wrap text-base text-gray-900">
                          <h2
                            className="text-lg text-gray-900 font-weight-bold underline"
                            style={{ fontSize: 18 }}
                          >
                            Microwave
                          </h2>
                          <div
                            className="text-base text-gray-900"
                            style={{ fontSize: 17 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.microwaveInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </IonLabel>
                      </IonItem>
                    ) : null}
                    {meal?.airFryInstructions ? (
                      <IonItem>
                        <IonLabel class="ion-text-wrap text-base text-gray-900">
                          <h2
                            className="text-lg text-gray-900 font-weight-bold underline"
                            style={{ fontSize: 18 }}
                          >
                            Air Fryer
                          </h2>
                          <div
                            className="text-base text-gray-900"
                            style={{ fontSize: 17 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.airFryInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </IonLabel>
                      </IonItem>
                    ) : null}
                    {meal?.ovenInstructions ? (
                      <IonItem lines="none">
                        <IonLabel class="ion-text-wrap text-base text-gray-900">
                          <h2
                            className="text-lg text-gray-900 font-weight-bold underline"
                            style={{ fontSize: 18 }}
                          >
                            Oven
                          </h2>
                          <div
                            className="text-base text-gray-900"
                            style={{ fontSize: 17 }}
                            dangerouslySetInnerHTML={{
                              __html: StringUtils.htmlToText(
                                meal?.ovenInstructions,
                              )
                                ?.replace(
                                  `Thawed / From The Fridge:`,
                                  `</br></br><span class="font-medium">Thawed / From The Fridge:</span></br>`,
                                )
                                ?.replace(
                                  `From The Freezer:`,
                                  `<span class="font-medium">From The Freezer:</span></br>`,
                                ),
                            }}
                          ></div>
                        </IonLabel>
                      </IonItem>
                    ) : null}
                  </>
                )}
              </IonList>
            </div>
          </>
        )}
      </div>

      <div
        className={`px-3 pb-5 ${(skeleton || !showReturnToApp) && "d-none"}`}
      >
        <IonButton
          color="primary"
          onClick={() => {
            history.push("/manage");
          }}
          className="pln-button-web-outline"
          fill="outline"
          expand="block"
          mode="ios"
        >
          Return To App
        </IonButton>
      </div>
      <IonModal
        ref={settingsRef}
        className="upcomingorder-settings-modal"
        initialBreakpoint={1}
        breakpoints={[0, 1]}
        mode="ios"
      >
        <div className="px-4 pt-4 pb-5" style={{ alignItems: "center" }}>
          <h4 className="font-weight-bold mt-3 text-dark mb-3 text-center">
            Review {meal?.name}
          </h4>
          {feedbackForm()}
        </div>
      </IonModal>
      <IonModal
        ref={settingsDesktopRef}
        presentingElement={presentingElement?.current}
        mode="ios"
      >
        <IonHeader>
          <IonToolbar
            mode={
              !nativeMode
                ? "ios"
                : Capacitor.getPlatform() == "ios"
                ? "ios"
                : "md"
            }
            className={
              nativeMode ? "modal-toolbar-native" : "box-modal-toolbar-web"
            }
            style={{ borderBottom: "none" }}
          >
            <IonTitle>Review {meal?.name}</IonTitle>
            <IonButtons slot="start">
              <IonButton
                color="dark"
                onClick={() => {
                  settingsDesktopRef?.current?.dismiss();
                }}
              >
                Close
              </IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton
                color={rating ? "primary" : "medium"}
                disabled={!rating || submitting}
                onClick={() => {
                  submitFeedback();
                }}
              >
                {submitting ? <IonSpinner name="dots"></IonSpinner> : "Submit"}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <div className="p-4">{feedbackForm(true)}</div>
        </IonContent>
      </IonModal>
      <MealDetailModal
        id="swapfor-modal"
        presentingElement={presentingElement}
        nativeMode={nativeMode}
      ></MealDetailModal>
    </>
  );
};

export default MealDetailContentV2;
